import React, { useState } from 'react';
import AiTextDialog from './AiTextDialog';
import { aiAPI } from '../../services/api';
import type { AiMatchSummaryStyle, AiNameStyle } from '../../types/ai';

interface AiMatchSummaryDialogProps {
  eventId: number;
  isOpen: boolean;
  onClose: () => void;
}

const STYLES: { value: AiMatchSummaryStyle; label: string }[] = [
  { value: 'parents', label: 'Üzenőfalra, a szülőknek' },
  { value: 'social', label: 'Közösségi médiába (Facebook)' },
  { value: 'report', label: 'Rövid, tárgyszerű összefoglaló' },
];

const NAME_STYLES: { value: AiNameStyle; label: string }[] = [
  { value: 'first', label: 'Keresztnévvel' },
  { value: 'full', label: 'Teljes névvel' },
  { value: 'none', label: 'Nevek nélkül' },
];

const selectClass =
  'mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-base sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary-500';

/** Mérkőzés-beszámoló az eredményből, a gólszerzőkből és az edző megjegyzéseiből. */
const AiMatchSummaryDialog: React.FC<AiMatchSummaryDialogProps> = ({ eventId, isOpen, onClose }) => {
  const [style, setStyle] = useState<AiMatchSummaryStyle>('parents');
  const [nameStyle, setNameStyle] = useState<AiNameStyle>('first');
  const [coachNotes, setCoachNotes] = useState('');

  return (
    <AiTextDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Mérkőzés-beszámoló AI-val"
      intro="Az AI a rögzített eredményből, a kezdőcsapatból és a gólszerzőkből ír beszámolót. Minél több adatot rögzítettél az Eredmény fülön, annál pontosabb lesz."
      generate={async () => (await aiAPI.matchSummary(eventId, { style, nameStyle, coachNotes: coachNotes.trim() || null })).content}
    >
      <label className="block text-sm font-medium text-gray-700">
        Hová szánod?
        <select value={style} onChange={(e) => setStyle(e.target.value as AiMatchSummaryStyle)} className={selectClass}>
          {STYLES.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </select>
      </label>
      <label className="block text-sm font-medium text-gray-700">
        A játékosok neve
        <select value={nameStyle} onChange={(e) => setNameStyle(e.target.value as AiNameStyle)} className={selectClass}>
          {NAME_STYLES.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </select>
        <span className="mt-1 block text-xs font-normal text-gray-500">
          Az AI nem látja a neveket, csak jelöléseket - a neveket a Portero teszi vissza a kész szövegbe.
        </span>
      </label>
      <label className="block text-sm font-medium text-gray-700">
        Saját megjegyzéseid (nem kötelező)
        <textarea
          rows={3}
          maxLength={1500}
          value={coachNotes}
          onChange={(e) => setCoachNotes(e.target.value)}
          placeholder="pl. az első félidőben nagyon jól presszingeltünk, a második félidőben elfáradtunk"
          className={selectClass}
        />
      </label>
    </AiTextDialog>
  );
};

export default AiMatchSummaryDialog;
